<template>

      <div style="width:1300px;margin:0 auto;">
            <div class="card mb-5 p-2" style="box-shadow: 10px 10px 5px #888888;margin-top:20px;">
                   <p class="mt-2" style="font-size:0.9rem;">
                    <span class="float-right span_close mr-1" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                    </span>
                   </p>
                   <div class="box row" style="margin:0 auto;">
                         <div class="col-3 p-0 nowarp">
                               <p class="pb-3">
                                <button class="btn content_time dian_zi vertical" @click="getDay()">
                                      
                                </button>
                                <span class="vertical">
                                    当天
                                </span>
                                 <button class="btn content_time dian_zi vertical" @click="getWeek()">
                                      
                                </button>
                                  <span class="vertical">
                                    当周
                                </span>
                                 <button class="btn content_time dian_zi vertical" @click="getMounth()">
                                      
                                </button>
                              
                                <span class="vertical">
                                    当月
                                </span>
                                 <button class="btn content_time dian_zi vertical" @click="getYear()">
                                      
                                </button>
                                <span class="vertical">
                                    当年
                                </span>
                               </p>
                              <p class="pb-3">
                                <button class="btn content dian_zi vertical"  @click="changeData(0)">
                                      
                                </button>
                                <span class="vertical">
                                    医药商城
                                </span>
                              </p>
                              <p class="pb-3">
                                <button class="btn content han_ning vertical" @click="changeData(1)">
                                      
                                </button>
                                <span class="vertical">
                                      汉宁
                                </span>
                              </p>
                              <p class="pb-3">
                                <button class="btn content gong_ye vertical" @click="changeData(2)">
                                      
                                </button>
                                <span class="vertical">
                                      工业
                                </span>
                              </p>
                              <p class="pb-3">
                                <button class="btn content xi_yao vertical" @click="changeData(3)">
                                      
                                </button>
                                <span class="vertical">
                                      西药
                                </span>
                              </p>
                              <p class="pb-3">
                                <button class="btn content xin_te vertical" @click="changeData(4)">
                                      
                                </button>
                                <span class="vertical">
                                      新特药
                                </span>
                              </p>
                              <p class="pb-3">
                                <button class="btn content yao_ping vertical" @click="changeData(5)">
                                      
                                </button>
                                <span class="vertical">
                                      药品
                                </span>
                              </p>
                              <p class="pb-3">
                                <button class="btn content yao_cai vertical" @click="changeData(6)">
                                      
                                </button>
                                <span class="vertical">
                                       药材
                                </span>
                              </p>
                              <p class="pb-3">
                                <button class="btn content yao_fang vertical" @click="changeData(7)">
                                      
                                </button>
                                <span class="vertical">
                                       连锁药房
                                </span>
                              </p>
                              <p v-if="tableData.length>8" class="pb-3">
                                <button class="btn content qi_xie vertical" @click="changeData(8)">
                                      
                                </button>
                                <span class="vertical">
                                       器械
                                </span>
                              </p>

                         </div>
                         <div class="col-9" id="myChart" :style="{width:'800px',height:'400px'}">
                      
                         </div>
                         <!-- <div id="myChart1" :style="{width:'1000px',height:'400px'}">
                              
                         </div> -->
                              <table class="table table-striped table-hover sett"  ref="print">
                                <thead>
                                    <tr style="text-align:center;">
                                        <th class="vt">公司</th>
                                        <th class="vt">
                                            零库销售
                                        </th>
                                        <th class="vt">总销售</th>
                                        <th class="vt">线上销售</th>
                                        <th class="vt">去年零库同期期末销售</th>
                                        <th class="vt">去年同期期末总销售</th>
                                        <th class="vt">去年线上同期期末销售</th>
                                        <th class="vt">去年现在零库销售</th>
                                        <th class="vt">去年现在总销售</th>
                                        <th class="vt">去年现在线上销售</th>
                                        <th class="vt">零库销售增长</th>
                                        <th class="vt">总销售增长</th>
                                        <th class="vt">线上销售增长</th>
                                        <th class="vt">零库增长率</th>
                                        <th class="vt">总增长率</th>
                                        <th class="vt">线上增长率</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in tableData" :key="index" style="text-align:center;">
                                        <td class="vt">{{item.brachNo | company}}</td>
                                        <td class="vt">{{item.nRetailAmount}}</td>
                                        <td class="vt">{{item.nTotalAmount}}</td>
                                        <td class="vt">{{item.nNetAmount}}</td>

                                        <td class="vt">{{item.pRetailAmount}}
                                             <br/>
                                            <span v-if="item.nRetailAmount==0">(完成率:<span style="color:red;">0.00%</span>)</span>
                                            <span v-else>(完成率:<span style="color:red;">{{ ((item.nRetailAmount/item.pRetailAmount)*100).toFixed(2)}}%</span>)</span>
                                        </td>
                                        <td class="vt">{{item.pTotalAmount}}
                                             <br/>
                                             <span v-if="item.nTotalAmout==0">(完成率:<span style="color:red;">0.00%</span>)</span>
                                            <span v-else>(完成率:<span style="color:red;">{{ ((item.nTotalAmount/item.pTotalAmount)*100).toFixed(2)}}%</span>)</span>
                                        </td>
                                        <td class="vt">{{item.pNetAmount}}
                                             <br/>
                                             <span v-if="item.nNetAmount==0">(完成率:<span style="color:red;">0.00%</span>)</span>
                                            <span v-else>(完成率:<span style="color:red;">{{ ((item.nNetAmount/item.pNetAmount)*100).toFixed(2)}}%</span>)</span>
                                        </td>
                                        
                                        <td class="vt">{{item.lRetailAmount}}</td>
                                        <td class="vt">{{item.lTotalAmount}}</td>
                                        <td class="vt">{{item.lNetAmount}}</td>
                                        <td class="vt">{{item.growthRetailAmount}}</td>
                                        <td class="vt">{{item.growthTotalAmount}}</td>
                                        <td class="vt">{{item.growthNetAmount}}</td>
                                        <td class="vt">{{GETRet(item.growthRetailRate,item.nRetailAmount,item.lRetailAmount)}}</td>
                                        <td class="vt">{{GETRet(item.growthTotalRate,item.nTotalAmount,item.lTotalAmount) }}</td>
                                        <td class="vt">{{GETRet(item.growthNetRate,item.nNetAmount,item.lNetAmount)}}</td>
                                    </tr>
									<tr style='color:red;text-align:center;'>
										<td class="vt">汇总</td>
                                      
                                        <td class="vt">{{Amount.nRetailAmount}}</td>
                                        <td class="vt">{{Amount.nTotalAmount}}</td>
                                        <td class="vt">{{Amount.nNetAmount}}</td>


                                        <td class="vt">{{Amount.pRetailAmount}}</td>
                                        <td class="vt">{{Amount.pTotalAmount}}</td>
                                        <td class="vt">{{Amount.pNetAmount}}</td>

                                        <td class="vt">{{Amount.lRetailAmount}}</td>
                                        <td class="vt">{{Amount.lTotalAmount}}</td>
                                        <td class="vt">{{Amount.lNetAmount}}</td>
                                        <td class="vt">{{Amount.growthRetailAmount}}</td>
                                        <td class="vt">{{Amount.growthTotalAmount}}</td>
                                        <td class="vt">{{Amount.growthNetAmount}}</td>
                                        <td class="vt">{{Amount.growthRetailRate}}</td>
                                        <td class="vt">{{Amount.growthTotalRate}}</td>
                                        <td class="vt">{{Amount.growthNetRate}}</td>
									</tr>
                                </tbody>
                              </table>
                           
                             <!-- <h5 class="ml-2">
                                <span class="weight">
                                    {{name}}
                                </span>
                                <span class="ml-2">
                                    相比去年
                                </span>
                                <span class="ml-2">
                                    零库销售增长
                                </span>
                                <span class="number">
                                    {{growthRetailAmount}}
                                </span>
                                <span class="ml-2">
                                   增长率
                                </span>
                                <span class="zeng">
                                    {{growthRetailRate}}
                                </span>
                                <span class="ml-2">
                                    总销售增长
                                </span>
                                <span class="number">
                                    {{growthTotalAmount}}
                                </span>
                                <span class="ml-2">
                                  增长率
                                </span>
                                <span class="zeng">
                                    {{ growthTotalRate}}
                                </span>
                                <span class="ml-2">
                                    线上销售增长
                                </span>
                                <span class="number">
                                    {{growthNetAmount}}
                                </span>
                                <span class="ml-2">
                                   增长率
                                </span>
                                <span class="zeng">
                                    {{growthNetRate}}
                                </span>
                             </h5> -->
                   </div>
                   
            </div>
      </div>
</template>

<script>
export default {
     data(){
         return{
            tableData:[],
            //想要展示的data
            data:[],
            data1:[],
            name:'',
            dateType:1,
            text:'销售分析(当天)',
            max: 5000000, 
            interval: 1000000,
            growthRetailAmount:'',
            growthRetailRate:'',
            growthTotalAmount:'',
             growthTotalRate:'',
             growthNetAmount:'',
             growthNetRate:'',
         }
     },
      filters: {
      company:function(item) {
               if(item==0){
                   return "医药商城"
               }
               else if(item==1){
                   return "汉宁"
               }
               else if(item==2){
                   return "工业"
               }
               else if(item==3){
                   return "西药"
               }
               else if(item==4){
                   return "新特药"
               }
               else if(item==5){
                   return "药品"
               }
               else if(item==6){
                   return "药材"
               }
               else if(item==8){
                   return "连锁药房"
               }
               else if(item==9){
                   return "器材"
               }
        } ,
   },
   computed: {
           
        //    WanCheng:function(){
        //          var _proList = this.tableData;
		// 		var	nRetailAmount = 0,nTotalAmount=0,nNetAmount=0,
		// 		pRetailAmount = 0,pTotalAmount=0,pNetAmount=0
		// 		for (var i = 0, len = _proList.length; i < len; i++) {
					
        //             pRetailAmount = (_proList[i].nRetailAmount/_proList[i].pRetailAmount)*100;
		// 			pTotalAmount = (_proList[i].nTotalAmount/_proList[i].pTotalAmount)*100;
		// 			pNetAmount = (_proList[i].nNetAmount/_proList[i].pNetAmount)*100;
                    
        //         }
        //         return {
					
        //             pRetailAmount: pRetailAmount.toFixed(2),
		// 			pTotalAmount: pTotalAmount.toFixed(2),
        //             pNetAmount:pNetAmount.toFixed(2),
                  
		// 		}
        //    },

			Amount: function() {
				var _proList = this.tableData;
				var	nRetailAmount = 0,nTotalAmount=0,nNetAmount=0,lRetailAmount=0,lTotalAmount=0,lNetAmount=0,growthRetailAmount=0,
				growthTotalAmount=0,growthNetAmount=0,growthRetailRate=0,growthTotalRate=0,growthNetRate=0,pRetailAmount = 0,pTotalAmount=0,pNetAmount=0
				for (var i = 0, len = _proList.length; i < len; i++) {
					//总价累加
					nRetailAmount += _proList[i].nRetailAmount;
					nTotalAmount += _proList[i].nTotalAmount;
                    nNetAmount += _proList[i].nNetAmount;

                    pRetailAmount += _proList[i].pRetailAmount;
					pTotalAmount += _proList[i].pTotalAmount;
					pNetAmount += _proList[i].pNetAmount;
                    

					lRetailAmount += _proList[i].lRetailAmount;
					lTotalAmount += _proList[i].lTotalAmount;
					lNetAmount += _proList[i].lNetAmount;
					growthRetailAmount += _proList[i].growthRetailAmount;
					growthTotalAmount += _proList[i].growthTotalAmount;
					growthNetAmount += _proList[i].growthNetAmount;
                }
                if(nRetailAmount>0){
                    if(lRetailAmount>0){
                        growthRetailRate=growthRetailAmount/lRetailAmount;
                        growthRetailRate=growthRetailRate*100;
                        growthRetailRate=growthRetailRate.toFixed(2) +'%';
                    }else{
                         growthRetailRate="P";
                    }
                   
                }else{
                   
                         growthRetailRate="L";
                    
                   
                }

               if(nTotalAmount>0){
                   if(lTotalAmount>0){
                             growthTotalRate=growthTotalAmount/lTotalAmount;
                            growthTotalRate=growthTotalRate*100;
                            growthTotalRate=growthTotalRate.toFixed(2) +'%';
                   }else{
                        growthTotalRate="P";
                   }
                   
                }else{
                  
                        growthTotalRate="L";
                    
                    
                }

                if(nNetAmount>0){
                    if(lNetAmount>0){
                                 growthNetRate=growthNetAmount/lNetAmount;
                                growthNetRate=growthNetRate*100;
                                growthNetRate=growthNetRate.toFixed(2)+'%';
                    }else{
                         growthNetRate="P";
                    }
                  
                }else{
                  
                        growthNetRate="L";
                    
                    
                }
				
			
				
				// growthNetRate=growthNetAmount/lNetAmount;
				// growthNetRate=growthNetRate*100;
				// growthNetRate=growthNetRate.toFixed(2);
				//选择产品的件数就是_proList.length，总价就是totalPrice
				
				return {
					
					nRetailAmount: nRetailAmount.toFixed(2),
					nTotalAmount: nTotalAmount.toFixed(2),
                    nNetAmount:nNetAmount.toFixed(2),

                    pRetailAmount: pRetailAmount.toFixed(2),
					pTotalAmount: pTotalAmount.toFixed(2),
                    pNetAmount:pNetAmount.toFixed(2),
                    
					lRetailAmount :lRetailAmount.toFixed(2),
					lTotalAmount:lTotalAmount.toFixed(2),
					lNetAmount:lNetAmount.toFixed(2),
					growthRetailAmount :growthRetailAmount.toFixed(2),
					growthTotalAmount:growthTotalAmount.toFixed(2),
					growthNetAmount:growthNetAmount.toFixed(2),
					growthRetailRate:growthRetailRate,
					growthTotalRate:growthTotalRate,
					growthNetRate:growthNetRate
				}
			}

		},
     methods:{
         GETRet(a,b,c){
                   if(b>=0){
                         
                         if(c>0){
                            return a+'%';
                         }else{
                             if(b==0&&c==0){
                                return '0%';
                             }
                             return 'P';  
                         }
                   }else{
                         return 'L';  
                    //    if(b==c){
                    //     return '0%'
                    //    }else{
                    //         if(b>c){
                            
                    //         return 'P';  
                    //     }else{
                    //          return 'L';  
                    //     }
                    //    }
                   }
            },
         //改变类型
         getDay(){
             this.dateType = 1;
             this.text="销售分析(当天)"
             this.max=5000000,
             this.interval=1000000,
             this.getSalesQuery();
         },
           getWeek(){
             this.dateType = 4;
             this.text="销售分析(当周)"
             this.max=5000000,
             this.interval=1000000,
             this.getSalesQuery();
         },
         getMounth(){
             this.dateType=2;
             this.text="销售分析(当月)"
             this.max=70000000,
             this.interval=10000000,
             this.getSalesQuery();
         },
         getYear(){
             this.dateType=3;
             this.text="销售分析(当年)"
             this.max=1000000000,
             this.interval=200000000,
             this.getSalesQuery();
         },
     //获得销售查询列表信息
         getSalesQuery: async function (PageIndex) {
        // this.isLoading=true;
        this.PageNo = PageIndex || this.PageNo
        const {data: res} = await this.$http.post('Dls/getFun', {
          action: 'SaleCompareDate',
          obj: JSON.stringify({
              dateType:this.dateType,
          })
        })
        // console.log(res)
        if (res.isok) {
          //this.isLoading = false
          const obj = res.data
          this.tableData = obj.rows
          this.changeData(0)
        //   console.log(this.tableData)
        //   this.Pcount = obj.pcount
        //   this.Record = obj.record
        //   this.totalNum = obj.totalNum
        //   this.totalMoney =obj.totalMoney
        //   this.pageTotalMoney=obj.pageTotalMoney
        }
      },
        //数据处理
        changeData(index){
             switch(index){
                 case 0:
                     this.name="医药商城"
                     break;
                 case 1:
                     this.name="汉宁"
                     break;
                 case 2:
                     this.name="工业"
                     break;
                 case 3:
                     this.name="西药"
                     break;
                 case 4:
                     this.name="新特药"
                     break;
                 case 5:
                     this.name="药品"
                     break;
                 case 6:
                     this.name="药材"
                     break;
                 case 7:
                     this.name="连锁药房"
                     break;
                 case 8:
                     this.name="器材"
                     break;
             }
             this.data=[];
             this.data.push(this.tableData[index].nRetailAmount,this.tableData[index].nTotalAmount,
             this.tableData[index].nNetAmount)
             this.growthRetailAmount=this.tableData[index].growthRetailAmount,
             this.growthRetailRate=this.tableData[index].growthRetailRate,
             this.growthTotalAmount=this.tableData[index].growthTotalAmount,
             this. growthTotalRate = this.tableData[index]. growthTotalRate,
             this.growthNetAmount = this.tableData[index].growthNetAmount,
             this.growthNetRate = this.tableData[index].growthNetRate,
             this.data1=[],
             this.data1.push(this.tableData[index].lRetailAmount,this.tableData[index].lTotalAmount,
             this.tableData[index].lNetAmount)
            //  console.log(this.data);
             this.drawLine()
            //  if(){

            //  }
            //  this.drawLine1()
             
        },
         //统计图
            drawLine(){
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('myChart'));
            // 绘制图表
            myChart.setOption({
                title: {
                    text:this.text,
                },
                //提示框组件，专门配置提示框的。
                tooltip: {
                    trigger:'axis',
                    // 坐标轴指示器配置项。
                    axisPointer:{
                        type:'cross', //指示器样试
                    }
                },
                //工具栏。内置有导出图片，数据视图，动态类型切换，数据区域缩放，重置五个工具。
                toolbox:{
                    feature:{
                        // 动态类型切换,切换图表
                        magicType: {
                            type: [ 'bar' ]
                        },
                        //数据视图工具，可以展现当前图表所用的数据，编辑后可以动态更新。
                        dataView:{
                            show:true,  //是否显示 数据示图
                            readOnly:false, //是否 直接可以编辑数据。
                        },
                        //保存为图片的配置
                        saveAsImage: {
                            show: true
                        },
                        //配置项还原
                        restore: {show: true},
                    }
                },
                //图例组件展现了不同系列的标记(symbol)，颜色和名字。可以通过点击图例控制哪些系列不显示。
                legend:{
                    data:['现在销售','去年现在销售'] //对应的是name
                },
                //配置X轴
                xAxis: {
                    //坐标轴类型
                    type:'category',
                    //配置类目名称。 可以逐一设置，具体看文档
                    data: ['零库销售','总销售','线上销售',],
                    //配置 鼠标移入时显示的 阴影指示器'line' 直线指示器 'shadow' 阴影指示,器  'none' 无指示器
                    axisPointer: {
                        show:true, //show 必须写，开关的作用
                        type: 'shadow'
                    },
                      name:this.name,//坐标轴名称。
                      nameLocation:'end',//坐标轴名称显示位置。
                     axisLabel : {//坐标轴刻度标签的相关设置。
                         interval:0,
                        //  rotate:"30"
                  }
                },
                //配置Y轴
                yAxis: [
                    {
                        type: 'value', //坐标轴类型
                        name: '销售', //名称
                        min: 0, //最小值
                        max: this.max, //最大值
                        interval: this.interval, //列数
                        axisLabel: {  //坐标轴刻度标签的相关设置。
                            formatter: '{value}'  //字符串模板
                        }
                    },
                ],
                //系列列表。每个系列通过 type 决定自己的图表类型,一个对象表示一个列表
                series: [
                    {
                        name: '现在销售',
                        type: 'bar',
                        //  data: [ 254655.62, 457918.72, 328546.35, 381125.47, 924731.79,924731.79,],
                        data:this.data,
                        itemStyle:{
                            normal:{
                                color:'#36d',
                                label:{
                                    show:true,
                                    position:'top',
                                    textStyle:{
                                         color: '#61a0a8'
                                    }
                                }
                            }
                            // color:['#CCC','#AFA', '#61a0a8', '#d48265', '#91c7ae','#749f83',  '#ca8622', '#bda29a','#6e7074',]
                        }
                    },
                    {
                        name: '去年现在销售',
                        type: 'bar',
                        data: this.data1,
                        itemStyle:{
                            normal:{
                                color:'#749f83',
                                label:{
                                    show:true,
                                    position:'top',
                                    textStyle:{
                                        color:'#749f83'
                                    }
                                }
                            }
                        }
                    }
                
                    
                ],
                //图表的颜色
                color:['#CCC','#AFA', '#61a0a8', '#d48265', '#91c7ae','#749f83',  '#ca8622', '#bda29a','#6e7074', '#546570', '#c4ccd3']
            });
            //鼠标事件
            myChart.on('click',function(params){
                console.log(params)
            })
        },
    //     drawLine1(){
    //         // 基于准备好的dom，初始化echarts实例
    //         let myChart = this.$echarts.init(document.getElementById('myChart1'));
    //         // 绘制图表
    //         myChart.setOption({
    //             title: {
    //     text: this.name+"相比去年",
    //     left: 'center'
    // },
    // tooltip: {
    //     trigger: 'item',
    //     formatter: '{a} <br/>{b} : {c} ({d}%)'
    // },
    // legend: {
    //     orient: 'vertical',
    //     left: 'left',
    //     data: ["今年减少", '今年销售']
    // },
    // series: [
    //     {
    //         name: '零库销售',
    //         type: 'pie',
    //         radius: '55%',
    //         // center: ['50%', '60%'],
    //         data: [
    //             {value: 274164.81, name: '今年减少'},
    //             {value: 151533.65, name: '今年销售'}
    //         ],
    //         emphasis: {
    //             itemStyle: {
    //                 shadowBlur: 10,
    //                 shadowOffsetX: 0,
    //                 shadowColor: 'rgba(0, 0, 0, 0.5)'
    //             }
    //         }
    //     },
    //     // {
    //     //     name: '零库销售',
    //     //     type: 'pie',
    //     //     radius: '55%',
    //     //     center: ['20%', '60%'],
    //     //     data: [
    //     //         {value: 274164.81, name: '今年减少'},
    //     //         {value: 151533.65, name: '今年销售'}
    //     //     ],
    //     //     emphasis: {
    //     //         itemStyle: {
    //     //             shadowBlur: 10,
    //     //             shadowOffsetX: 0,
    //     //             shadowColor: 'rgba(0, 0, 0, 0.5)'
    //     //         }
    //     //     }
    //     // },

    // ]
    //         });
          
    //     }

     },
     mounted(){
         this.drawLine();
        //  this.drawLine1();
     },
     created(){
          this.getSalesQuery();
        //   this.changeData(0)
     }

}
</script>
<style scoped>
    .content{
        width:50px;
        height:20px;
        display: inline-block;
        border-radius:5px;
    }
    .content_time{
        width:40px;

    }
    .dian_zi{
        background-color:#36d;
    }
    .vertical{
        vertical-align: middle;
    }
    .han_ning{
        background-color:yellow;
    }
    .gong_ye{
        background-color:blue;
    }
    .xi_yao{
        background-color:pink;
    }
    .xin_te{
        background-color:aqua;
    }
    .yao_ping{
        background-color:brown;
    }
    .yao_cai{
        background-color:chartreuse;
    }
    .yao_fang{
        background-color:coral;
    }
    .qi_xie{
        background-color:cyan;
    }
    .zeng{
        color:green;
    }
    .number{
        color:#36d;
    }
    .weight{
        font-weight: bold;
    }
     .span_close:hover{
       color:#3190e8;
 }
 .yysc{
     color:#36d;
 }
 .hn{
     color:yellow;
 }
 .vt{
     vertical-align:middle;
 }
 

.table td, .table th {
    padding: 0.5rem !important
  
}
 
</style>



// WEBPACK FOOTER //
// src/pages/manager/SalesQuery.vue